//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "exchangeItemForm",
  components: {},
  props: ["defualtData", "exchangeIndex"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      formData: {
        name: "",
        value: ""
      },
      ruleValidate: {
        name: [{
          required: true,
          message: "原始值不能为空",
          trigger: "blur"
        }],
        value: [{
          required: true,
          message: "显示值不能为空",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    getData: function getData() {
      return this.formData;
    },
    removeItem: function removeItem() {
      this.$emit("removeItem");
    },
    getDefualtData: function getDefualtData() {
      this.formData = JSON.parse(JSON.stringify(this.defualtData));
    }
  },
  watch: {},
  filters: {}
};